var map = {
	"./en.json": [
		1702,
		60
	],
	"./et.json": [
		1703,
		59
	],
	"./fi.json": [
		1704,
		58
	],
	"./lv.json": [
		1705,
		57
	],
	"./pl.json": [
		1706,
		56
	],
	"./ru.json": [
		1707,
		55
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 1699;


//////////////////
// WEBPACK FOOTER
// ./src/i18n lazy ^\.\/.*\.json$
// module id = 1699
// module chunks = 62